import {useRef} from "react";
import {fetchArticle} from "@/features/article/api/articleApi";

export const usePagination = ({source, categoryId, page, perPage}) => {
    const isLoading = useRef(false);

    const changePage = (pageNumber) => {
        if (isLoading.current || page === pageNumber) return;
        isLoading.current = true;

        fetchArticle(source,{
            categoryId,
            page: pageNumber,
            perPage,
        }, {
            onFinish: () => {
                isLoading.current = false;
            }
        });
    };

    return {changePage};
};
